import * as React from 'react';

const FormInputContext = React.createContext(undefined);

/**
 * FormInputProvider
 *
 * @param {children} formElement
 * @param {autoAdvance} autoAdvance
 * @description React Context Provider pattern, wrapping children with context. This is used to provide the autoAdvance prop to all children. This is used to determine if the form should auto advance on input change.
 */
const FormInputProvider = ({ children, autoAdvance }) => {
  const contextValue = React.useMemo(() => ({ autoAdvance }), [autoAdvance]);

  return (
    <FormInputContext.Provider value={contextValue}>
      {children}
    </FormInputContext.Provider>
  );
};

// TODO we seem to be using autoAdvance via prop rather than the context, so we should refactor this to use the context or remove this context entirely
export const useFormInputContext = () => {
  const context = React.useContext(FormInputContext);

  if (context === undefined) {
    return { autoAdvance: false };
  }
  return context;
};

export default FormInputProvider;
